var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu_list"},_vm._l((_vm.links),function({to, name, activeExact = false}){return _c('li',{key:name},[_c('router-link',{staticClass:"menu_item",attrs:{"to":to,"active-class":"menu_item__active","exact":activeExact}},[_vm._v(" "+_vm._s(name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }